function initReadMore() {
	let containerTop = document.querySelector(".read-more-top .rich-text__content");
	let containerBottom = document.querySelector(".read-more-bottom .rich-text__content");

	if (!containerTop && !containerBottom) {
		return;
	}handleReadMoreButton(containerTop, "show-more-container-top", 50);handleReadMoreButton(containerBottom, "show-more-container-bottom", 200);}

function handleReadMoreButton(descriptionContainer, classToAdd, height) {
	let descriptionDiv = descriptionContainer.querySelector(".mega-description");
	if (descriptionDiv && descriptionDiv.innerHTML.trim() !== '' && parseInt(descriptionDiv.offsetHeight) > height) {
		if (!descriptionContainer.querySelector(".show-more")) {
			descriptionDiv.classList.add(classToAdd);
			addReadMoreButton(descriptionContainer);
		}
	}
}

function addReadMoreButton(element) {
	const divContainer = document.createElement('div');
	divContainer.classList.add('read-more-wrapper');

	const button = document.createElement('a');
	button.textContent = 'Læs mere';
	button.classList.add('show-more');

	divContainer.appendChild(button);
	element.appendChild(divContainer);
	button.addEventListener('click', function () {
		element.querySelector(".mega-description").style.height = "auto";
		button.style.display = "none";
	});
}

function removeReadMoreButton() {
	document.querySelectorAll(".show-more").forEach(button => button.remove());
	document.querySelectorAll(".mega-description").forEach(desc => {
		desc.classList.remove("show-more-container-top", "show-more-container-bottom");
		desc.style.height = "";
	});
}

function handleReadMoreInit() {
	if (parseInt(screen.width) <= 1138) {
		initReadMore();
	} else {
		removeReadMoreButton();
	}
}

handleReadMoreInit();

window.addEventListener("resize", function () {
	handleReadMoreInit();
});
